import styled from "styled-components";

const OverlayContent = styled.div`
	visibility: hidden;

	min-width: max-content;
`;

export default OverlayContent;
